<span
  class="rating"
  tabindex="0"
  role="slider"
  aria-valuemin="0"
  [attr.aria-valuemax]="ratingRange.length"
  [attr.aria-valuenow]="rating">
  @for (item of ratingRange; track item; let index = $index) {
    <span>
      <i
        [attr.data-icon]="fullIcon"
        class="{{ iconClass }} half{{ calculateWidth(item) }}"
      [title]="titles[index] || item">{{ emptyIcon }}</i>
    </span>
  }
</span>